var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"doughnutChart",staticClass:"doughnut-chart",staticStyle:{"border":"1px solid #ececec","border-radius":"10px","box-shadow":"3px 3px 3px #ececec"}})
}
var staticRenderFns = []

export { render, staticRenderFns }